export class Note {
  public id: string;
  public personId: string;
  public description: string;
  public createdBy: string;
  public createdOn: Date;
  public entityId: string;
  public entityType?: NoteEntityType;
  public actionType?: NoteActionType;
  public actionTypeText: string;
  public subtitle: string;

  constructor(note: any = undefined) {
    if (note) this.setProperties(note);
  }

  private setProperties(note: any) {
    this.id = note.id;
    this.personId = note.personId;
    this.description = note.description;
    this.createdBy = note.createdBy;
    this.createdOn = note.createdOn;
    this.entityId = note.entityId;
    this.entityType = note.entityType;
    this.actionType = note.actionType;
    this.subtitle = note.subtitle;
  }
}

export enum NoteEntityType {
  PersonScenario = 'PersonScenario',
  PersonRequirement = 'PersonRequirement',
}

export enum NoteActionType {
  CompletePersonScenario = 'CompletePersonScenario',
  ArchivePersonScenario = 'ArchivePersonScenario',
  DeletePersonScenario = 'DeletePersonScenario',
  CompletePersonRequirement = 'CompletePersonRequirement',
}
